import { deepCopy } from './functions/functions.js';
import axios from 'axios';


// Constants
const openModal = () => {
    return {
        modal: {
            value: false,
            variant: 'sw-nuevo',
            title: 'Nuevo',
            size: 'md',
            modal: '',
            loaded: false,
            data: null
        },

    }
}
const saveConfig = () => {
    return {
        notification: {
            title: 'Datos guardados con éxito',
            content: '',
            error: false,
            view: false,
            color: false,
        },
        saveloading: false,
        loading: true,
        capa: false,
        agrupar: false,
        autofocus: false,
        popoverShow: false,
    }
}

function reset() {
    var returnReset = {
        saveConfig: saveConfig(),
        openModal: openModal(),
        horaServer: null,
        indexData: false,
        formatter: false,
        pushSave: false,
        openMenuMovil: false,
        windowSize: 0,
    }
    return returnReset
}
// State
export const state = {
    horaServer: reset()['horaServer'],
    pushSave: reset()['pushSave'],
    indexData: reset()['indexData'],
    saveConfig: reset()['saveConfig'],
    openModal: reset()['openModal'],
    openMenuMovil: reset()['openMenuMovil'],
    windowSize: reset()['windowSize'],
    url: window.location.origin.replace(":8080", ":8000")
};

// Getters
export const getters = {};

// Mutations
export const mutations = {
    changeGlobal(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            if (data.boolean === '') {
                switch (listState.length) {
                    case 1:
                        state[listState[0]] = !state[listState[0]]
                        callback(true)
                        break
                    case 2:
                        state[listState[0]][listState[1]] = !state[listState[0]][listState[1]]
                        callback(true)
                        break
                    case 3:
                        state[listState[0]][listState[1]][listState[2]] = !state[listState[0]][listState[1]][listState[2]]
                        callback(true)
                        break
                    case 4:
                        state[listState[0]][listState[1]][listState[2]][listState[3]] = !state[listState[0]][listState[1]][listState[2]][listState[3]]
                        callback(true)
                        break
                    case 5:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                        callback(true)
                        break
                    case 6:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                        callback(true)
                        break
                    case 7:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                        callback(true)
                        break
                    case 8:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                        callback(true)
                        break
                    case 9:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = !state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                        callback(true)
                        break
                }
            } else {

                switch (listState.length) {
                    case 1:
                        state[listState[0]] = data.boolean
                        callback(true)
                        break
                    case 2:
                        state[listState[0]][listState[1]] = data.boolean
                        callback(true)
                        break
                    case 3:
                        state[listState[0]][listState[1]][listState[2]] = data.boolean
                        callback(true)
                        break
                    case 4:
                        state[listState[0]][listState[1]][listState[2]][listState[3]] = data.boolean
                        callback(true)
                        break
                    case 5:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = data.boolean
                        callback(true)
                        break
                    case 6:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = data.boolean
                        callback(true)
                        break
                    case 7:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = data.boolean
                        callback(true)
                        break
                    case 8:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = data.boolean
                        callback(true)
                        break
                    case 9:
                        state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = data.boolean
                        callback(true)
                        break
                }
            }
        } catch (error) {
            console.log('error in globalStore/mutation/change,', error)
        }
    },
    updateGlobal(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state[listState[0]] = deepCopy(data.data)
                    break
                case 2:
                    state[listState[0]][listState[1]] = deepCopy(data.data)
                    break
                case 3:
                    state[listState[0]][listState[1]][listState[2]] = deepCopy(data.data)
                    break
                case 4:
                    state[listState[0]][listState[1]][listState[2]][listState[3]] = deepCopy(data.data)
                    break
                case 5:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = deepCopy(data.data)
                    break
                case 6:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = deepCopy(data.data)
                    break
                case 7:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = deepCopy(data.data)
                    break
                case 8:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = deepCopy(data.data)
                    break
                case 9:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = deepCopy(data.data)
                    break
            }
            callback(true)
        } catch (error) {
            console.log('error in globalStore/mutation/updateGlobal,', error)
            callback(false)
        }
    },
    resetGlobal(state, { data, callback }) {
        try {
            var listState = data.state.split('/')
            switch (listState.length) {
                case 1:
                    state[listState[0]] = reset()[listState[0]]
                    break
                case 2:
                    state[listState[0]][listState[1]] = reset()[listState[0]][listState[1]]
                    break
                case 3:
                    state[listState[0]][listState[1]][listState[2]] = reset()[listState[0]][listState[1]][listState[2]]
                    break
                case 4:
                    state[listState[0]][listState[1]][listState[2]][listState[3]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]]
                    break
                case 5:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]]
                    break
                case 6:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]]
                    break
                case 7:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]]
                    break
                case 8:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]]
                    break
                case 9:
                    state[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]] = reset()[listState[0]][listState[1]][listState[2]][listState[3]][listState[4]][listState[5]][listState[6]][listState[7]][listState[8]]
                    break
            }
            callback(true)

        } catch (error) {
            console.log('error in globalStore/mutation/reset,', error)
            callback(false)
        }
    },
};
// Actions
export const actions = {
    changeGlobal({ commit }, data) {
        return new Promise((resolve) => {
            commit('changeGlobal', { data: data, callback: resolve })
        })
    },
    pushGlobal({ commit }, data) {
        return new Promise((resolve) => {
            commit('pushGlobal', { data: data, callback: resolve })
        })
    },
    spliceGlobal({ commit }, data) {
        return new Promise((resolve) => {
            commit('spliceGlobal', { data: data, callback: resolve })
        })
    },
    resetGlobal({ commit }, data) {
        return new Promise((resolve) => {
            commit('resetGlobal', { data: data, callback: resolve })
        })
    },
    updateGlobal({ commit }, data) {
        return new Promise((resolve) => {
            commit('updateGlobal', { data: data, callback: resolve })
        })
    },
};